import { useController, UseControllerProps } from "react-hook-form";
import "react-quill-new/dist/quill.snow.css";
import { AavoRichTextEditor } from "src/components/common/inputFields/AavoRichTextEditor.tsx";
import type { AavoRichTextEditorProps } from "src/components/common/inputFields/AavoRichTextEditor.tsx";
import { FormFieldLayoutProps, formFieldLayoutPropsToSx } from "src/components/common/forms/styles.ts";
import { mergeSx } from "src/utils/styles.ts";

export interface FormRichTextEditorProps<TFieldValues extends object>
	extends AavoRichTextEditorProps,
		FormFieldLayoutProps {
	control: UseControllerProps<TFieldValues>["control"];
	name: UseControllerProps<TFieldValues>["name"];
}

export const FormRichTextEditor = <TFieldValues extends object>({
	control,
	name,
	spanGridColumns,
	startNewGridRow,
	sx,
	...other
}: FormRichTextEditorProps<TFieldValues>) => {
	const { field } = useController({
		name,
		control,
	});

	return (
		<AavoRichTextEditor
			value={field.value}
			onChange={(newValue, _delta, source) => {
				// Without source check the onChange will be called on mount.
				// react-quill seems format the value and then call onChange.
				// This causes form field to be marked as dirty on mount.
				if (source === "user") {
					field.onChange(newValue);
				}
			}}
			onBlur={field.onBlur}
			readOnly={field.disabled}
			sx={mergeSx(
				formFieldLayoutPropsToSx({
					spanGridColumns,
					startNewGridRow,
				}),
				sx,
			)}
			{...other}
		/>
	);
};
